import React from 'react'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, Text } from 'react-native'
import { IconPlus2 } from '../../../assets/icons'

export const AddOwner: React.FC<{ onPress: () => void }> = ({ onPress }) => {
  const { t } = useTranslation('global')
  return (
    <TouchableOpacity
      style={{
        width: '100%',
        height: 51,
        borderRadius: 16,
        borderWidth: 2,
        borderColor: '#00A0F3',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F4F9FD',
        flexDirection: 'row',
        marginTop: 20,
      }}
      onPress={onPress}
    >
      <IconPlus2 width={16} height={16} style={{ marginRight: 10 }} />
      <Text style={{ fontWeight: '700', fontSize: 14, color: '#222B45' }}>
        {t('ProjectForm.add-another-owner')}
      </Text>
    </TouchableOpacity>
  )
}
